var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.b(),{'avue-queue--block':_vm.block}]},[_c('div',{ref:"queue",staticClass:"animated",class:_vm.animate},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }